module.exports = __webpack_public_path__ + "static/media/rocketPicture.684380af.svg";